/**
 * Delete the property in an object according to the array of keys
 * @param obj The object being manipulated
 * @param keys Array of keys
 * @param index Where to start
 * @returns Whether the deletion is successful
 */
export function deleteObjectProperty(
  obj: unknown,
  keys: Array<string | number>,
  index: number = 0,
): boolean {
  if (obj == null || typeof obj !== 'object') {
    return false;
  }

  for (let i = index; i < keys.length - 1; i++) {
    obj = (obj as { [key: string]: unknown })[keys[i]];
    if (obj == null || typeof obj !== 'object') {
      return false;
    }
  }

  delete (obj as { [key: string]: unknown })[keys[keys.length - 1]];

  return true;
}
